import type { HTMLProps } from 'react';

type VideoThumbnailProps = HTMLProps<HTMLDivElement> & {
  src: string;
};

const VideoThumbnail = ({ className, src, ...props }: VideoThumbnailProps) => (
  <div {...props} className={`w-40 max-w-full sm:w-80 ${className ? className : ''}`}>
    <div className="relative h-0" style={{ paddingTop: '100%' }}>
      <video className="absolute top-0 h-full w-full object-cover" src={src} muted />
    </div>
  </div>
);

export default VideoThumbnail;
